import { AxiosResponse } from 'axios'

import ClientSDK from '../../../../App/ClientSDK'

import { IHoliday, IApiHoliday } from './IHoliday'
import Transformer from './Transformer'

class Client {
  static getHolidays = (countryCode: string): Promise<IHoliday[]> =>
    ClientSDK.instance()
      .get(`holidays/${countryCode}`)
      .then((response: AxiosResponse): IHoliday[] => {
        return response.data.data.map((data: IApiHoliday) =>
          Transformer.transform(data),
        )
      })
}

export default Client
